import base from "../base.js";
import screenSize from "../definition/screenSize.js";

export default class Size extends base {
    objectType = "Size";
    _width = 0;
    _height = 0;
    maxSizeX = screenSize.width;
    maxSizeY = screenSize.height;

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        super.objectToClassValue({...args, canBeHide: false, show: false});
        if (args.width && !args.largeur)
            args.largeur = args.width;
        if (args.height && !args.hauteur)
            args.hauteur = args.height;
        this.maxSizeX = args.maxSizeX != undefined ? args.maxSizeX : screenSize.width;
        this.maxSizeY = args.maxSizeY != undefined ? args.maxSizeY : screenSize.height;
        this.width = args.width !== undefined ? args.width : args.largeur !== undefined ? args.largeur : screenSize.width;
        this.height = args.height !== undefined ? args.height : args.hauteur !== undefined ? args.hauteur : screenSize.height;
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "width", text: "Largeur", construct: Number, jsType: "Number" },
            { property: "height", text: "Hauteur", construct: Number, jsType: "Number" },
        ];
    }

    static get Name() {
        return "Taille";
    }

    get width() {
        return this._width;
    }

    set width(width) {
        let x = 0;
        if (this.parent != null && this.parent.x != null) {
            x = this.parent.x;
        }
        if (this.maxSizeX != -1 && x + width > this.maxSizeX) {
            width = this.maxSizeX - x;
        }
        if (width <= 0)
            width = 1;
        this._width = Math.floor(width);
    }

    get height() {
        return this._height;
    }

    set height(height) {
        let y = 0;
        if (this.parent != null && this.parent.y != null) {
            y = this.parent.y;
        }
        if (this.maxSizeY != -1 && y + height > this.maxSizeY) {
            height = this.maxSizeY - y;
        }
        if (height <= 0)
            height = 1;
        this._height = Math.floor(height);
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            {name:"width", type:"numberInput", dataType: "number"},
            {name:"height", type:"numberInput", dataType: "number"},
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            width: this.width,
            height: this.height,
        }
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            width: this.width,
            height: this.height,
        }
    }

    static fromObject(object = {}) {
        return new this.prototype.constructor(object);
    }
}
